import React from 'react';
import { Box, Image, Grid, Text, Container, Button } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { useDisclosure } from '@chakra-ui/hooks';
import Modal from "../Components/EarlySignUp";






function MainArea(){
    const { isOpen, onOpen, onClose } = useDisclosure();
    return(
        <div>
            <Box mt={["20px", "20px", "20px", "80px"]}>
                <Grid templateColumns={["repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(2, 1fr)"]} gap={0}>
                    <Box my="1.8rem" mx={[0, 0, 0, 5]}>
                        <Text fontSize={["2rem", "2rem", "2rem", "3.125rem"]} fontWeight="800">
                            Create unforgettable experiences with 
                            like minded people.
                        </Text>
                        <Text fontSize="1.15rem" fontWeight="600" lineHeight="1.7" mt="10px" w="90%" color="#4f8df7">
                            Exploring and connecting to your community made simple. 
                        </Text>
                        <Button mt="30px" bg="#6ea3ff" color="white" p={7} borderRadius="90px" _hover={{backgroundColor: "#4f8df7"}} onClick={onOpen}>
                    Early Signup
                </Button>
                <Modal onClose={onClose} onOpen={onOpen} isOpen={isOpen}  />

                    </Box>
                    <Image mt={[4, 4, 4, 0]} src="https://do1pg20gb8r9m.cloudfront.net/design1.png" />
                </Grid>
                
            </Box>
        </div>
    )
}

function Hangouts(){
    return(
        <div>
            <Box>
           
                <Text fontSize={["2rem", "2rem", "2rem", "3.125rem"]} fontWeight="800">
                    Hangouts
                </Text>
                <Text  fontWeight="800" mt="20px" w={["100%", "100%", "100%", "70%"]} >
                    Your community is filled with amazing opportunities to participate, share and meet new people. Hangouts are the one place to get to do all of those things and more. 
                </Text>

                <Grid templateColumns={["repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(2, 1fr)"]} gap={6} my={5}>
                    <Box>
                        <Image src="https://do1pg20gb8r9m.cloudfront.net/in-person-min.jpg" 
                        borderRadius="10px"
                        h="350px"
                        w="100%"
                        objectFit="cover"
                        />
                        <Box my={5}>
                            <Text fontSize="2rem" fontWeight="800" >
                                In-Person Hangout
                            </Text>
                            <Text fontSize="1rem" fontWeight="600" lineHeight="1.7">
                                Socially Distanced In-Person Hangouts with small groups 
                            </Text>
                        </Box>
                    </Box>
                    <Box>
                        <Image src="https://do1pg20gb8r9m.cloudfront.net/online-min.jpg" 
                        borderRadius="10px"
                        h="350px"
                        w="100%"
                        objectFit="cover"
                        />
                        <Box my={5}>
                            <Text fontSize="2rem" fontWeight="800" >
                                Online Hangout
                            </Text>
                            <Text fontSize="1rem" fontWeight={"600"} lineHeight="1.7">
                                Join a Hangout right from home using a phone or computer
                            </Text>
                        </Box>
                    </Box>

                </Grid>
                
            </Box>
        </div>
    )
}

function Hosts(){
    return(
        <div>
     

            <Box>
            <Text fontSize={["2rem", "2rem", "2rem", "3.125rem"]} fontWeight="800">
                    Hosts
                </Text>
       
                
                <Grid templateColumns={["repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(2, 1fr)"]} gap={10} my={5}>

                    <Box w="100%" >
                    <Image src="https://do1pg20gb8r9m.cloudfront.net/hosts-min.jpg" 
                        borderRadius="10px"
                        h="350px"
                        w="100%"
                        objectFit="cover"
                        />
                    </Box>

                    <Box my="auto">
                
                        <Text fontWeight="800" my="auto" fontSize="20px">
                            Your community will benefit a lot from what you can offer. People love your craft, practice it with new people and make money in the process. 
                        </Text>
                        <Link to="/hosts">
                            <Button mt="30px" bg="#6ea3ff" color="white" p={7} borderRadius="90px" _hover={{backgroundColor: "#4f8df7"}} >
                                Learn more
                            </Button>
                        </Link>
                    </Box>
                 
                </Grid>
            </Box>
        </div>
    )
}

function HowItWorks(){
    return(
        <div>
            <Box>
                <Text fontSize={["2rem", "2rem", "2rem", "3.125rem"]} fontWeight="800">
                    How it works
                </Text>
                
                <Grid templateColumns={["repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(2, 1fr)"]} gap={10} my={5}>

                    <Box w="100%" >
                        {/* <video width="50%" style={ {height: "100%",  objectFit: "cover"}} autoPlay muted playsInline loop  >
                            <source src="https://do1pg20gb8r9m.cloudfront.net/demoWorks.mp4"  type="video/mp4" />
                        </video> */}
                        <Grid templateColumns="repeat(2, 1fr)" >
                            {/* <Image src="https://do1pg20gb8r9m.cloudfront.net/Group 55-min.png" w="100%" />
                            <Image src="https://do1pg20gb8r9m.cloudfront.net/Group 52-min.png" w="100%" /> */}
                            <Image src="https://do1pg20gb8r9m.cloudfront.net/mockups/Home.png" w="100%" />
                            <Image src="https://do1pg20gb8r9m.cloudfront.net/mockups/Hangout 1.png" w="100%" />
                        </Grid>
                    </Box>
                
                        <Text fontWeight="800" my="auto" fontSize="20px">
                            Hosts create in-person or online hangouts. We help distribute the Hangouts to the community and they can purchase a ticket to the hangout to participate.
                        </Text>
                 
                </Grid>
            </Box>
        </div>
    )
}


function OurCulture(){
    return(
        <div>
            <Box w={["100%", "60%", "60%", "60%"]}>
                <Text fontSize={["2rem", "2rem", "2rem", "3.125rem"]} mt="20px" fontWeight="800">
                    Our Culture
                </Text>
                <Box mt="20px">
                    <Text  fontWeight="800" my="auto" fontSize="20px" color="#4f8df7">
                        Be yourself
                    </Text>
                    <Text  fontSize="1rem" fontWeight="600" lineHeight="1.7">
                        You are the best when you are true yourself.
                    </Text>
                </Box>
                <Box mt="20px">
                    <Text  fontWeight="800" my="auto" fontSize="20px" color="#4f8df7">
                        Be mindful 
                    </Text>
                    <Text  fontSize="1rem" fontWeight="600" lineHeight="1.7">
                        Of others’ time and be present when hanging out.
                    </Text>
                </Box>

                <Box mt="20px">
                    <Text  fontWeight="800" my="auto" fontSize="20px" color="#4f8df7">
                        Create and attend any type of Hangout
                    </Text>
                    <Text  fontSize="1rem" fontWeight="600" lineHeight="1.7">
                        We encourage the People of Proximy to always be themselves, ensuring that aligns with Proximy’s Community Guidelines.
                    </Text>
                </Box>

                <Box mt="20px">
                    <Text  fontWeight="800" my="auto" fontSize="20px" color="#4f8df7">
                        We are built around Community
                    </Text>
                    <Text  fontSize="1rem" fontWeight="600" lineHeight="1.7">
                        The People of Proximy support each other by being hosts and participants, being students and supporters of others in the community and their craft.
                    </Text>
                </Box>

                <Box mt="20px">
                    <Text  fontWeight="800" my="auto" fontSize="20px" color="#4f8df7">
                        There is zero tolerance
                    </Text>
                    <Text  fontSize="1rem" fontWeight="600" lineHeight="1.7">
                        For any form of Racism, Hate Speech, Abusive Language. Proximy is built to bring people together while ensuring they remain themselves, loving not only what they do, but each and every part of themselves.
                    </Text>
                </Box>


            </Box>
        </div>
    )
}





export default function Landing(){
    return(
        <div>
            <Container maxW={["90%", "90%", "90%", "85%"]} mb={15} p={[0, 0, 0, 4]}>
                <MainArea/>
            </Container>
            <Box  py={8}>
                <Container maxW={["90%", "90%", "90%", "80%"]} mb={15} p={[0, 0, 0, 4]}>
                    <Hangouts/>
                 
                </Container>
            </Box>
         
                <Container maxW={["90%", "90%", "90%", "80%"]} mb={24} p={[0, 0, 0, 4]}>
                    <Hosts/>
                 
                </Container>
          
            <Container maxW={["90%", "90%", "90%", "80%"]} mb={20} py={8} p={[0, 0, 0, 4]}>
                <HowItWorks/>
            </Container>

            <Box >
                <Image src="https://do1pg20gb8r9m.cloudfront.net/lastBanner.jpg" />
            </Box>

            <Container maxW={["90%", "90%", "90%", "80%"]} mb={16} py={8} p={[0, 0, 0, 4]}>
                <OurCulture/>
            </Container>




            <br/>

        </div>
    )
};